<!-- @format -->

<template>
	<pc-crud
		ref="crud"
		:height="tableHeight"
		:data="listData"
		:toolbars="listConfig.toolbars"
		:search-form="listConfig.searchForm"
		:pk-key="pkKey"
		:columns="listConfig.columns"
		:pagination="pagination"
		:loading="loading"
		:selection-type="multiple ? 'checkbox' : 'radio'"
		@selection-change="handleSelectionChange"
		@action-event="handleAction"
		@sort-change="handleSortChange"
		@pagination-change="handlePaginationChange"
	/>
</template>
<script>
	import SelectionMixin from '../pcp-selector-dialog/mixins/selection';
	import { queryPageList } from '@/api/position/index';
	import { ActionUtils } from '@/utils/action';
	import { $utils } from '@/utils/publicUtils';
	import { PcCrud } from '@/components/pc-crud/index';

	export default {
		components: { PcCrud },
		mixins: [SelectionMixin],
		props: {
			value: [Object, Array],
			multiple: Boolean,
			height: {
				type: String,
				default: '400px',
			},
		},
		data() {
			return {
				pkKey: 'id', // 主键  如果主键不是pk需要传主键
				loading: false,
				listData: [],
				listConfig: {
					// 查询条件
					searchForm: {
						selector: true,
						labelWidth: 90,
						forms: [
							{ prop: 'Q^NAME_^SL', label: '用户组名称' },
							{ prop: 'Q^GROUP_ALIAS_^SL', label: '用户组别名' },
						],
					},
					// 表格字段配置
					columns: [
						{ prop: 'name', label: '用户组名称', slotName: 'trans' },
						{ prop: 'groupAlias', label: '用户组别名' },
					],
				},
				pagination: {},
				sorts: {},
			};
		},
		computed: {
			tableHeight() {
				const h = this.height.substr(0, this.height.length - 2);
				return parseInt(h) - 10;
			},
		},
		created() {
			this.loadListData();
		},
		beforeUnmount() {
			this.listData = null;
			this.listConfig = null;
			this.pagination = null;
			this.sorts = null;
		},
		methods: {
			// 加载数据
			loadListData() {
				this.loading = true;
				queryPageList(this.getFormatParams())
					.then((response) => {
						this.loading = false;
						ActionUtils.handleListData(this, response);
						this.setSelectRow();
					})
					.catch(() => {
						this.loading = false;
					});
			},
			// 获取格式化参数
			getFormatParams() {
				const params = this.$refs.crud ? this.$refs.crud.getSearcFormData() : {};
				Object.assign(params, { inclueChild: this.inclueChild ? 'Y' : 'N' });
				if ($utils.isNotEmpty(this.partyId)) {
					Object.assign(params, { partyType: this.partyType, partyId: this.partyId });
				}
				return ActionUtils.formatParams(params, this.pagination, this.sorts);
			},
			// 处理分页事件
			handlePaginationChange(page) {
				this.changePageCoreRecordData();
				ActionUtils.setPagination(this.pagination, page);
				this.loadListData();
			},
			// 处理排序
			handleSortChange(sort) {
				ActionUtils.setSorts(this.sorts, sort);
				this.loadListData();
			},
			//  查询
			search() {
				this.loadListData();
			},
			// 重置查询
			resetSearch() {
				this.$refs.crud ? this.$refs.crud.resetSearch() : null;
				ActionUtils.setFirstPagination(this.pagination);
				this.search();
			},
			// 处理按钮事件
			handleAction(command) {
				switch (command) {
					case 'search':
						// 查询
						ActionUtils.setFirstPagination(this.pagination);
						this.search();
						break;
					case 'resetSearch':
						// 重置查询
						this.resetSearch();
						break;
					default:
						break;
				}
			},
		},
	};
</script>
